var angular = require('angular')
require('./services/app.dataservice')
require('./components/tab/tab.component')
require('./pages/dps/dps.component')
require('./pages/pp/pp.component')

angular.module('AemCspsDisbursementCalculator')
  .controller('AemCspsDisbursementCalculatorCtrl', AemCspsDisbursementCalculatorCtrl)

AemCspsDisbursementCalculatorCtrl.$inject = ['appLoader', 'appDataservice']
function AemCspsDisbursementCalculatorCtrl (appLoader, appDataservice) {
  var vm = this

  vm.$onInit = function () {
    appLoader.hide()
    vm.appDataservice = appDataservice
  }
}
